notifications-read-indicator
  .user
    i.feather.icon-user(class="{bg-c-green: !opts.unread} {bg-c-gray: opts.unread}" data-toggle="tooltip" data-placement="top" data-original-title="{userName()}")
  script(type="typescript").
    this.mixin('notifications.read-indicator');
  style(scoped).
    :scope {
      display: inline-block;
      text-align: right;
    }
    .icon-user {
      display: inline-block;
      width: 14px;
      height: 14px;
      font-size: 8px;
      padding: 2px 2px;
      margin-left: 2px;
      border-radius: 50%;
      text-align: center;
      color: #fff;
    }
    .bg-c-gray {
      background: #CBCBCB;
    }
